<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

                    <div v-if="tenant_id == 0" class="alert alert-warning mt-3">
                        <span class="ti-alert mr-1"></span>
                        No tenant selected. Go back to the list and pick a tenant before creating a coupon.
                    </div>

                    <form @submit.prevent="addNew" class="h-100">

                        <!-- Content -->
                        <div class="tab-content">

                            <CouponForm
                                ref="form"
                                :row="row"
                                :errors="errors"
                                :tenant-id="tenant_id"
                                :existing-codes="existingCodes">
                            </CouponForm>

                        </div>
                        <!-- End Content -->

                        <div class="col-md-12 row">
                            <div class="form-group mr-2">
                                <button class="btn btn-primary" :disabled="btnLoading || tenant_id == 0">
                                    <span v-if="btnLoading">
                                        <span class="spinner-grow spinner-grow-sm mr-1"
                                            role="status" aria-hidden="true">
                                        </span>Loading...
                                    </span>
                                    <span v-if="!btnLoading" class="ti-check-box"></span>
                                    <span v-if="!btnLoading"> Create Coupon</span>
                                </button>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-danger"
                                    :disabled="btnLoading"
                                    @click="cancel">
                                    <span class="ti-close"></span>
                                    <span> Cancel </span>
                                </button>
                            </div>
                        </div>

                    </form>
                </div>

                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->

    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import CouponForm from './Form.vue';
    import iziToast from 'izitoast';

    export default {
        name: 'Create',
        components: {
            Header,
            Navigation,
            Footer,
            CouponForm
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    code: '',
                    name: '',
                    discount_type: 'percentage',
                    discount_value: '',
                    valid_from: '',
                    valid_to: '',
                    min_booking_value: '',
                    usage_limit: '',
                    packagesValues: [],
                    status: 1,
                },
                errors: {},
                existingCodes: [],

                pgLoading: false,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'coupons',
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchExistingCodes();
        },
        methods: {

            // existing codes for the "already exists" hint
            fetchExistingCodes(){
                if(this.tenant_id == 0) { return; }
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs,
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 1,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.existingCodes = res.data.coupons || [];
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // Add New
            addNew(){
                this.errors = {};

                if(this.tenant_id == 0) {
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenant selected.'
                    });
                    return;
                }

                if(!this.$refs.form.validate()) {
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'Please fix the highlighted fields.'
                    });
                    return;
                }

                this.btnLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs,
                    method: 'POST',
                    data: this.$refs.form.buildPayload(),
                }
                this.axios(options)
                    .then(res => {
                        this.btnLoading = false;
                        iziToast.success({
                            icon: 'ti-check',
                            title: 'Great job,',
                            message: (res.data && res.data.message) ? res.data.message : 'Coupon created successfully.',
                        });
                        this.$router.push({ name: this.refs });
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        // 401 / 403
                        if(err.response && err.response.status == 401) {
                            this.removeLocalStorage();
                            this.$router.push({ name: 'login' });
                        } else if(err.response && err.response.status == 403) {
                            this.$router.push({ name: 'forbidden' });
                        } else if(err.response && err.response.status == 422) {
                            this.errors = (err.response.data && err.response.data.errors) ? err.response.data.errors : {};
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: err.response.data.message || 'Validation failed.'
                            });
                        } else {
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: (err.response && err.response.data) ? err.response.data.message : ''+err
                            });
                        }
                    })
                    .finally(() => {})
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
